"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PURCHASES = void 0;
const helpers_1 = require("../../client/helpers");
exports.GET_PURCHASES = `
  query GetPurchases($cursor: String) {
    purchases(cursor: $cursor, limit: 25) {
      cursor
      entities {
        id
        type
        status
        createdAt
        expiresAt
        metaSiteId
        currency
        price
      }
    }
  }
`;
//# sourceMappingURL=purchases.queries.js.map